import React from "react";
import { hydrate } from "react-dom";
// import { BrowserRouter } from 'react-router-dom';
import App from "./App";

import { Provider } from "react-redux";
// import Loadable from 'react-loadable';
import { Frontload } from "react-frontload";
import { ConnectedRouter } from "connected-react-router";
import createStore from "./redux/store";

// constants
window.ENABLE_2FA = decodeURIComponent(escape(atob(window.CONSTANTS[0])));
window.TAG = decodeURIComponent(escape(atob(window.CONSTANTS[1])));
window.NODE_ENV = decodeURIComponent(escape(atob(window.CONSTANTS[2])));
window.MAX_UPLOAD_FILESIZE = decodeURIComponent(
  escape(atob(window.CONSTANTS[3])),
);
window.ANP_CREATION_FREEZE = decodeURIComponent(
  escape(atob(window.CONSTANTS[4])),
);
window.ENABLE_NGUM_SWITCH = decodeURIComponent(
  escape(atob(window.CONSTANTS[5])),
);
window.TESTING = decodeURIComponent(
  escape(atob(window.CONSTANTS[6])),
);

if (window.NODE_ENV === "production") {
  console.log("Running in production mode");
  window.console.log = function () {};
} /*  else {
  console.log('Running in development mode');
  window.console.log = function() {};
} */

const { store, history } = createStore();
const Application = (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Frontload noServerRender={true}>
        <App />
      </Frontload>
    </ConnectedRouter>
  </Provider>
);

hydrate(Application, document.getElementById("root"));

if (module.hot) {
  module.hot.accept();
}
